import { Component as ComponentContainer } from '@styles/layout';
import { HotelTileGroupComponent } from '@model/content';
import { HotelTileGroup } from './HotelTileGroup';

export const HotelTileGroupContainer = (props: HotelTileGroupComponent) => {
  return (
    <ComponentContainer>
      <HotelTileGroup {...props} />
    </ComponentContainer>
  );
};
